// contexts/ForgotPasswordContext.js
import React, { createContext, useContext } from 'react';
import axios from 'axios';
import { BASE_URL } from '../config/config';

const ForgotPasswordContext = createContext();

export const ForgotPasswordProvider = ({ children }) => {
  const sendResetLink = async (email) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/forget-password`,
        { email },
        { headers: { 'Content-Type': 'application/json' } }
      );

      return response.data;
    } catch (error) {
      throw error?.response?.data || { message: 'An error occurred' };
    }
  };

  return (
    <ForgotPasswordContext.Provider value={{ sendResetLink }}>
      {children}
    </ForgotPasswordContext.Provider>
  );
};

export const useForgotPassword = () => useContext(ForgotPasswordContext);
